module.exports = __webpack_public_path__ + "static/media/hasalon_thumb_even.0750bdb3.webp";